module.exports = __webpack_public_path__ + "img/083.4840da1c.png";